import React, { useEffect, useState } from "react";
import BlogClasses from "./index.module.css";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import { Services } from "Services";
import SkeletonLoad from "Components/TableLoad/load";
import { Error, Error_Dark, SuccessSwal, warningSwal } from "Util/Toast";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { FaRegEdit, FaSearch } from "react-icons/fa";
import { AccessControl } from "Util/AccessControl";
import { AccessKeys } from "Routes/config";
import swal from "sweetalert";
import { AiFillDelete } from "react-icons/ai";
import Loader from "Components/loader/loader";

function Blogs() {
    const [loading, setLoading] = useState(true);
    const [actionLoad, setActionLoad] = useState(false);
    const [data, setData] = useState([]);
    const [searchString, setSearchString] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const Navigate = useNavigate();

    const getAllBlogs = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (statusFilter) params.set("Status", statusFilter);
        params.set("Limit", "200");
        Services.getBlogPosts("GET", null, token, `?${params.toString()}`)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.BlogPosts || []);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                Error_Dark("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getAllBlogs();
        // eslint-disable-next-line
    }, [statusFilter]);

    const filteredData = data.filter((item) =>
        searchString
            ? (item.Heading || "")
                  .toLowerCase()
                  .includes(searchString.toLowerCase()) ||
              (item.Slug || "").toLowerCase().includes(searchString.toLowerCase())
            : true
    );

    const addHandler = () => {
        Navigate("/Blogs/add");
    };
    const editHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let id = e.currentTarget.getAttribute("id");
        Navigate(`/Blogs/edit?id=${id}`);
    };

    const toggleHandler = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        let id = e.currentTarget.getAttribute("id");
        try {
            setActionLoad(true);
            const response = await Services.toggleBlogPublish(
                "PUT",
                null,
                token,
                id
            );
            if (response.Status === 1) {
                SuccessSwal("Success", response.Message);
                setData((prev) =>
                    prev.map((item) =>
                        String(item.BlogPostID) === String(id)
                            ? { ...item, Status: response.PostStatus }
                            : item
                    )
                );
            } else {
                warningSwal("Warning", response.Message);
            }
        } catch (err) {
            Error_Dark("something went wrong please try again");
            console.log(err);
        } finally {
            setActionLoad(false);
        }
    };

    const deleteHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let id = e.currentTarget.getAttribute("id");
        swal("Are you sure you want to delete this blog post?", {
            icon: "warning",
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Delete",
                },
            },
        }).then(async (value) => {
            if (value === "Delete") {
                try {
                    setActionLoad(true);
                    const response = await Services.deleteBlogPost(
                        "DELETE",
                        null,
                        token,
                        id
                    );
                    if (response.Status === 1) {
                        SuccessSwal("Success", response.Message);
                        setData((prev) =>
                            prev.filter(
                                (item) => String(item.BlogPostID) !== String(id)
                            )
                        );
                    } else {
                        warningSwal("Warning", response.Message);
                    }
                } catch (err) {
                    Error_Dark("something went wrong please try again");
                    console.log(err);
                } finally {
                    setActionLoad(false);
                }
            }
        });
    };

    return (
        <Layout Active={"Blogs"}>
            {actionLoad && <Loader />}
            <Helmet>
                <meta charSet="utf-8" />
                <title>Blogs</title>
            </Helmet>
            <div className={BlogClasses["Container"]}>
                <div className={BlogClasses["control-btns"]}>
                    <button
                        className={BlogClasses["button"]}
                        onClick={addHandler}>
                        Add Blog
                    </button>{" "}
                    <div>
                        <FaSearch className={BlogClasses["search-icon"]} />
                        <input
                            onChange={(e) => setSearchString(e.target.value)}
                            value={searchString}
                            type="text"
                            placeholder="Search by heading or slug"
                        />
                    </div>
                    <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="published">Published</option>
                        <option value="draft">Draft</option>
                    </select>
                </div>
                <div className={BlogClasses["Tutor"]}>
                    <h3>Blogs</h3>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "Heading",
                                "Category",
                                "Status",
                                "Posted On",
                                "Actions",
                            ]}
                        />
                    ) : filteredData.length > 0 ? (
                        <div className={BlogClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Heading</th>
                                        <th>Category</th>
                                        <th>Status</th>
                                        <th>Posted On</th>
                                        {AccessControl(AccessKeys.Blogs)
                                            ?.edit === 1 && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((item) => (
                                        <tr key={item.BlogPostID}>
                                            <td>{item.Heading}</td>
                                            <td>{item.Category}</td>
                                            <td
                                                className={
                                                    item.Status === "published"
                                                        ? BlogClasses[
                                                              "Status-active"
                                                          ]
                                                        : BlogClasses[
                                                              "Status-inactive"
                                                          ]
                                                }>
                                                <span>{item.Status}</span>
                                            </td>
                                            <td>
                                                {item.PostedOn ? (
                                                    <Moment format="DD-MM-YYYY">
                                                        {new Date(
                                                            item.PostedOn
                                                        )}
                                                    </Moment>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            {AccessControl(AccessKeys.Blogs)
                                                ?.edit === 1 && (
                                                <td>
                                                    <div
                                                        className={
                                                            BlogClasses[
                                                                "Action-btns"
                                                            ]
                                                        }>
                                                        <button
                                                            id={
                                                                item.BlogPostID
                                                            }
                                                            onClick={
                                                                editHandler
                                                            }
                                                            title="Edit">
                                                            <FaRegEdit />
                                                        </button>
                                                        <button
                                                            id={
                                                                item.BlogPostID
                                                            }
                                                            onClick={
                                                                toggleHandler
                                                            }
                                                            title={
                                                                item.Status ===
                                                                "published"
                                                                    ? "Move to draft"
                                                                    : "Publish"
                                                            }>
                                                            {item.Status ===
                                                            "published"
                                                                ? "Unpublish"
                                                                : "Publish"}
                                                        </button>
                                                        <button
                                                            id={
                                                                item.BlogPostID
                                                            }
                                                            onClick={
                                                                deleteHandler
                                                            }
                                                            title="Delete">
                                                            <AiFillDelete color="red" />
                                                        </button>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            <p>No Blogs Found</p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Blogs;
